/* istanbul ignore file */

import { CommonModule, DOCUMENT } from '@angular/common';
import {
  Component,
  computed,
  contentChild,
  contentChildren,
  inject,
  input,
  Signal,
  TemplateRef,
} from '@angular/core';

import {
  semanticParsing,
  SemanticParsingOptions,
  SemanticText,
} from '@yoimo/client-sdk/pages';

import {
  findTemplateOverride,
  TemplateOverrideDirective,
} from '../tpl-override.directive';

type UnifiedSemanticNode =
  | Exclude<SemanticText[number], string>
  | { type: 'TEXT'; text: string };
// Small component that renders some text that goes
// through a parser and renders the contents using
@Component({
  selector: 'joymo-parsed-text-block',
  templateUrl: './parsed-text-block.component.html',
  imports: [CommonModule],
  standalone: true,
})
export class ParsedTextBlockComponent {
  readonly _document = inject(DOCUMENT);
  inputText = input.required<string>();
  baseUrl = input<string>();
  _realBaseUrl = computed(() => this.baseUrl() ?? this._document.location.href);

  overrides = contentChildren(TemplateOverrideDirective);

  urlTpl = findTemplateOverride(this.overrides, 'url');
  videoPosTpl = findTemplateOverride(this.overrides, 'videoPos');

  parserOptions = input<SemanticParsingOptions>({ parseUrls: true });
  _parserOptions = computed<SemanticParsingOptions>(() => {
    const options = this.parserOptions();
    return {
      parseTags: false,
      parseUrls: options.parseUrls || !!this.urlTpl(),
      parseVideoCustorTarget: !!this.videoPosTpl(),
    };
  });

  nodes = computed<UnifiedSemanticNode[]>(() => {
    const parsed = semanticParsing(
      this.inputText(),
      new URL(this._realBaseUrl()),
      this._parserOptions()
    );
    return parsed.map((s) =>
      typeof s === 'string' ? { type: 'TEXT', text: s } : s
    );
  });
}
